"use strict";"use client";import{usePageTrackerHandler as r}from"./use-page-tracker-handler";export const PageTracker=e=>(r(e),null);
